import { render, staticRenderFns } from "./ConversationDialog.vue?vue&type=template&id=2fdf3342&scoped=true"
import script from "./ConversationDialog.vue?vue&type=script&lang=js"
export * from "./ConversationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConversationDialog.vue?vue&type=style&index=0&id=2fdf3342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf3342",
  null
  
)

export default component.exports